import Ergebnisse from './Ergebnisse';
export default Ergebnisse;
